<template>
  <div>

    <Loader cover v-if="local.isProcessing"/>
    <ListTable/>

  </div>
</template>

<script>
  import {state} from './data';

  export default {
    components: {
      Loader: () => import('@/components/common-ui/loader-block/index.vue'),
      ListTable: () => import('./SubComponents/VdoSetList'),
    },
    data() {
      return {
        state: state,
        local: state.local,
      }
    },
  }
</script>
